export const FIRST_NAME_FIELD = '::firstname::'
export const LAST_NAME_FIELD = '::lastname::'
export const TEXTING_NUMBER_FIELD = '::mobilephone::'
export const PRIMARY_EMAIL_FIELD = '::primaryemail::'

export type PreviewField = {
	readonly field: string
	readonly columnIndex?: number
	readonly required: boolean
}

export const PREVIEWED_FIELDS_DEFAULT: ReadonlyArray<PreviewField> = [
	{ field: FIRST_NAME_FIELD, columnIndex: undefined, required: true },
	{ field: LAST_NAME_FIELD, columnIndex: undefined, required: true },
	{ field: TEXTING_NUMBER_FIELD, columnIndex: undefined, required: true },
	{ field: PRIMARY_EMAIL_FIELD, columnIndex: undefined, required: false },
]
